/**
 * Class util for date
 */
export default class DateUtil {

    /**
     * Returns the current timestamp in s
     *
     * @returns {Number} Current timestamp in seconds
     */
    static getCurrentTimestamp() {
        return Math.floor(Date.now() / 1000);
    }

    /**
     * Returns the current timestamp in ms
     *
     * @returns {Number} Current timestamp in seconds
     */
    static getCurrentTimestampMs() {
        return Date.now();
    }
}


// WEBPACK FOOTER //
// ./js/core/utils/DateUtil.js